import Checkbox from 'components/elements/atoms/Checkbox';
import { getAppIds } from '../SyncCourses';

export default function TopicList({
  loading,
  topics,
  selectedTopics,
  onChange,
  app,
}) {
  const appId = getAppIds(app).topicId;

  if (loading)
    return (
      <div
        className="fa fa-spin fa-spinner text-primary spinner"
        style={{ fontSize: '16px' }}
      />
    );

  const toggle = (topic) => {
    const exists = selectedTopics.some((t) => t[appId] === topic[appId]);
    if (exists) {
      onChange(selectedTopics.filter((t) => t[appId] !== topic[appId]));
    } else {
      onChange([...selectedTopics, topic]);
    }
  };

  return (
    <div>
      {topics.map((topic) => (
        <Checkbox
          className="mb-2 d-block"
          key={topic[appId]}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            toggle(topic);
          }}
          checked={selectedTopics.some((t) => t[appId] === topic[appId])}
          disabled={false}
        >
          {topic.name}
        </Checkbox>
      ))}
    </div>
  );
}
